import { defineComponent } from 'vue';
import Input from '../../../input';
export default defineComponent({
    compatConfig: { MODE: 3 },
    name: 'FilterSearch',
    inheritAttrs: false,
    props: {
        value: String,
        onChange: Function,
        filterSearch: Boolean,
        tablePrefixCls: String,
        locale: { type: Object, default: undefined },
    },
    setup(props) {
        return () => {
            const { value, onChange, filterSearch, tablePrefixCls, locale } = props;
            if (!filterSearch) {
                return null;
            }
            return (<div class={`${tablePrefixCls}-filter-dropdown-search`}>
          <Input placeholder={locale.filterSearchPlaceholder} onChange={onChange} value={value} 
            // for skip min-width of input
            htmlSize={1} condition allow-clear class={`${tablePrefixCls}-filter-dropdown-search-input`}/>
        </div>);
        };
    },
});
